document.addEventListener('DOMContentLoaded', function () {

  const variantImageMap = {
    'Armoured Double Layered Case': [0, 1, 2],
    'Glass Case': [3, 4, 5],
    'Stride 2.0 Case': [6, 7, 8]
  };

  let currentAllowedPositions = null;
  let thumbnails = [];

  function goToThumb(index) {
    if (thumbnails[index]) {
      thumbnails[index].click();
    }
  }

  function filterImages(variantOptions) {
    const mediaItems = document.querySelectorAll('.product__media-item[data-media-type="image"]');
    thumbnails = [...document.querySelectorAll('button.product__thumbnail-item[data-media-id]')];

    if (mediaItems.length === 0) return;

    let allowedPositions = null;
    for (const [key, positions] of Object.entries(variantImageMap)) {
      if (variantOptions.includes(key)) {
        allowedPositions = positions;
        break;
      }
    }

    if (!allowedPositions) {
      mediaItems.forEach(item => item.style.display = '');
      thumbnails.forEach(item => item.style.display = '');
      currentAllowedPositions = null;
      return;
    }

    currentAllowedPositions = allowedPositions;

    goToThumb(allowedPositions[0]);

    thumbnails.forEach(function (thumb, index) {
      thumb.style.display = allowedPositions.includes(index) ? '' : 'none';
    });

    mediaItems.forEach(function (item) {
      const pos = parseInt(item.getAttribute('data-original-position'));
      item.style.display = allowedPositions.includes(pos) ? '' : 'none';
    });

    setTimeout(function () {
      goToThumb(allowedPositions[0]);
    }, 100);
  }

  // ✅ Reliable on-load variant detection
  function getSelectedOptions() {
    return [...document.querySelectorAll('.product-form__input input:checked, .product-form__input option:checked')]
      .map(el => el.value);
  }

  function runOnLoad() {
    const options = getSelectedOptions();
    if (options.length > 0) {
      filterImages(options);
      return true;
    }

    // ✅ Fallback: read variant from URL
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    if (variantId && window.variantData) {
      const variant = window.variantData.find(v => String(v.id) === variantId);
      if (variant) {
        const opts = [variant.option1, variant.option2, variant.option3].filter(Boolean);
        filterImages(opts);
        return true;
      }
    }

    return false;
  }

  // ✅ Try immediately, then retry a few times if theme hasn't rendered yet
  let attempts = 0;
  const loadInterval = setInterval(function () {
    attempts++;
    const success = runOnLoad();
    if (success || attempts >= 10) {
      clearInterval(loadInterval);
      // If nothing matched after 10 tries, default to Armoured
      if (!success) filterImages(['Armoured Double Layered Case']);
    }
  }, 200); // Try every 200ms for up to 2 seconds

  // Loop observer
  function handleSliderLoop() {
    if (!currentAllowedPositions) return;
    const activeItem = document.querySelector('.product__media-item.is-active, .product__media-item[aria-current="true"], .product__media-item.is-selected');
    if (!activeItem) return;
    const activePos = parseInt(activeItem.getAttribute('data-original-position'));
    if (!currentAllowedPositions.includes(activePos)) {
      goToThumb(currentAllowedPositions[0]);
    }
  }

  const observer = new MutationObserver(function () {
    handleSliderLoop();
  });

  setTimeout(function () {
    const mediaContainer = document.querySelector('.product__media-list, .product__media-wrapper');
    if (mediaContainer) {
      observer.observe(mediaContainer, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'aria-current', 'style']
      });
    }
  }, 500);

  document.addEventListener('variant:changed', function (e) {
    const variant = e.detail && e.detail.variant;
    if (!variant) return;
    const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    filterImages(options);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.closest('.product-form')) return;
    filterImages(getSelectedOptions());
  });

});
